import { type ReactNode } from 'react';
import { type CellRendererParamsContext } from '@components/Table/types';
import { type ComponentCreateRequestMapped } from '../../utils/contexts/NotificationComponentsContext';
import { type RequestTableContext } from '../models/RequestTableContext';

export function UserCell(
    params: CellRendererParamsContext<
        ComponentCreateRequestMapped,
        RequestTableContext
    >,
): ReactNode {
    const data = params.data;

    if (!data?.user) {
        return;
    }

    const user = data.user;
    return user ? `${user.firstName} ${user.lastName}` : 'Unknown user';
}
